function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.566 30L15 18.561 26.434 30 30 26.433 18.572 15 30 3.567 26.434 0 15 11.439 3.566 0 0 3.567 11.428 15 0 26.433 3.566 30z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "30",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.566 30L15 18.561 26.434 30 30 26.433 18.572 15 30 3.567 26.434 0 15 11.439 3.566 0 0 3.567 11.428 15 0 26.433 3.566 30z",
  fill: "currentColor"
}))));